import React from 'react'

import ImageWithText from '@/components/flows/WalkthroughFlow/components/ImageWithText'
import screenshotUrl from '@/components/flows/WalkthroughFlow/steps/2_ProfessionalNetworkScreen3/screenshot.png'

const ProfessionalNetworkScreen3: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p className="mb-4">
        Dive into key data about your professional connections. Track
        relationship health, revenue generated, and your clients' experience.
      </p>
    }
  />
)

export default ProfessionalNetworkScreen3
